import { queryClient } from "src/lib/react-query";
import { useGetCepContentBlocksQuery } from "src/graphql";

/**
 * Fire-and-forget loader that warms the content-blocks query cache so the
 * Overview tab can resolve `{% ht_content_block %}` tags on first render
 * without a skeleton flash. Used by both campaign and message detail routes.
 */
export const prefetchContentBlocks = async () => {
  void queryClient.fetchQuery({
    queryKey: useGetCepContentBlocksQuery.getKey(),
    queryFn: useGetCepContentBlocksQuery.fetcher(),
  });
  return null;
};
